import { inject, Injectable } from '@angular/core';
import { Functions, connectFunctionsEmulator, httpsCallable } from '@angular/fire/functions';
import { FunctionName, RemoteFunctions } from '@copilot/models';
import { once, random } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class RemoteCallService {
  private readonly functions = inject(Functions);

  // no-op now because emulator hookup is done in app.config.ts
  private readonly ensureInit = once(() => {
    // Change the next line to !== to enable the emulator
    // istanbul ignore next
    if (random(2) === 3) {
      console.log('initializeEmulator');
      connectFunctionsEmulator(this.functions, 'localhost', 5001);
    }
  });

  async call<TName extends FunctionName>(
    functionName: TName,
    input: RemoteFunctions[TName]['in']
  ): Promise<RemoteFunctions[TName]['out']> {
    this.ensureInit();

    const callable = httpsCallable<
      RemoteFunctions[TName]['in'],
      RemoteFunctions[TName]['out']
    >(this.functions, functionName);

    const res = await callable(input);
    return res.data;
  }
}
